import { LinkField } from "../../linkField"

export const IconBar = ({ ibItems, bkgColour, ctaButton }) => {
  return (
    <div className={`${bkgColour === "White" ? "" : "bg-bgcard"}`}>
      <div className="items-center justify-center w-full gap-5 py-10 align-bottom mxl-auto color-black md:flex">
        <div className="container justify-center mx-auto md:flex md:flex-wrap">
          {ibItems?.map((item, index) => (
            <div
            key={index}
            className="flex flex-col items-center p-8 md:px-4 md:py-8 md:flex-none md:w-1/3"
          >
            {item.svgIcon[0].url && (
              <img
                src={item.svgIcon[0].url}
                referrerPolicy="no-referrer"
                alt={item.heading}
                className="w-12 h-12"
              />
            )}
            <h3 className="mt-10 text-xl font-bold text-center md:h-8 text-secondary">
              {item.heading}
            </h3>
            <div
              className="mt-5 text-base text-center align-text-bottom redactor text-secondary md:p-4"
              dangerouslySetInnerHTML={{ __html: item.rContent }}
            />
          </div>
        ))}
      </div>
      </div>
      {ctaButton && (
        <div className="flex justify-center my-4">
          <LinkField
            {...ctaButton}
            className="inline-block px-10 py-4 font-semibold text-center text-white rounded bg-pink hover:bg-btnhover"
          >
            {ctaButton.text}
          </LinkField>
        </div>
      )}
    </div>
  )
}
